var _rect, _path, _path2, _path3, _path4, _circle, _circle2, _ellipse, _circle3, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSshTunnelError = function SvgSshTunnelError(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 120,
    viewBox: "0 0 349 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 349,
    height: 117,
    transform: "translate(0 3)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.168 43.6494C198.168 30.7058 187.675 20.2129 174.731 20.2129C161.788 20.2129 151.295 30.7058 151.295 43.6494V78.7098C151.295 81.2943 153.39 83.3895 155.975 83.3895H193.488C196.073 83.3895 198.168 81.2944 198.168 78.7098V43.6494Z",
    fill: "url(#paint0_linear_3048_301592)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.053 48.2152C192.053 37.8964 183.688 29.5312 173.369 29.5312C163.05 29.5312 154.685 37.8964 154.685 48.2152V76.166C154.685 78.2264 156.355 79.8968 158.416 79.8968H188.322C190.382 79.8968 192.053 78.2264 192.053 76.166V48.2152Z",
    fill: "url(#paint1_linear_3048_301592)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183.32 53.2837C183.32 45.5137 177.021 39.2148 169.251 39.2148C161.481 39.2148 155.183 45.5137 155.183 53.2837V74.3304C155.183 75.8819 156.44 77.1397 157.992 77.1397H180.511C182.063 77.1397 183.32 75.882 183.32 74.3304V53.2837Z",
    fill: "url(#paint2_linear_3048_301592)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.305 60.9263C174.305 55.6459 170.024 51.3652 164.744 51.3652C159.463 51.3652 155.183 55.6459 155.183 60.9263V75.2294C155.183 76.2838 156.037 77.1385 157.092 77.1385H172.396C173.45 77.1385 174.305 76.2838 174.305 75.2294V60.9263Z",
    fill: "url(#paint3_linear_3048_301592)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.04,
    cx: 197.5,
    cy: 25.5,
    r: 25.5,
    fill: "#EF5350"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.11,
    cx: 197.5,
    cy: 25.5,
    r: 18.5,
    fill: "#EF5350"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.563,
    cy: 98.9964,
    rx: 23.4365,
    ry: 3.05693,
    fill: "#EDEDED"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.5,
    cy: 25.5,
    r: 11.625,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197.501 12.584C190.384 12.584 184.584 18.3836 184.584 25.5007C184.584 32.6177 190.384 38.4173 197.501 38.4173C204.618 38.4173 210.417 32.6177 210.417 25.5007C210.417 18.3836 204.618 12.584 197.501 12.584ZM196.532 20.334C196.532 19.8044 196.971 19.3652 197.501 19.3652C198.03 19.3652 198.469 19.8044 198.469 20.334V26.7923C198.469 27.3219 198.03 27.7611 197.501 27.7611C196.971 27.7611 196.532 27.3219 196.532 26.7923V20.334ZM198.689 31.1581C198.624 31.3261 198.534 31.4552 198.418 31.5844C198.289 31.7006 198.146 31.7911 197.991 31.8556C197.836 31.9202 197.669 31.959 197.501 31.959C197.333 31.959 197.165 31.9202 197.01 31.8556C196.855 31.7911 196.713 31.7006 196.584 31.5844C196.467 31.4552 196.377 31.3261 196.312 31.1581C196.248 31.0031 196.209 30.8352 196.209 30.6673C196.209 30.4994 196.248 30.3315 196.312 30.1765C196.377 30.0215 196.467 29.8794 196.584 29.7502C196.713 29.634 196.855 29.5436 197.01 29.479C197.32 29.3498 197.681 29.3498 197.991 29.479C198.146 29.5436 198.289 29.634 198.418 29.7502C198.534 29.8794 198.624 30.0215 198.689 30.1765C198.754 30.3315 198.792 30.4994 198.792 30.6673C198.792 30.8352 198.754 31.0031 198.689 31.1581Z",
    fill: "#EF5350"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3048_301592",
    x1: 210.396,
    y1: 33.4596,
    x2: 166.58,
    y2: 52.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF295C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3048_301592",
    x1: 201.801,
    y1: 40.0918,
    x2: 166.87,
    y2: 55.5264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF295C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3048_301592",
    x1: 190.661,
    y1: 47.1668,
    x2: 164.358,
    y2: 58.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF295C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021549"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3048_301592",
    x1: 179.293,
    y1: 56.7693,
    x2: 161.418,
    y2: 64.6676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF295C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021549"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSshTunnelError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ssh-tunnel-error.e89b4d96ffd69f243a7b272f1b6ead8a.svg";